const mockPropertyDetails = {
    agent: {
        isExclusive: false,
    },
    airConditioning: false,
    apartmentAmenities: [

    ],
    balconyDeckPatioPorch: false,
    canBeArchived: true,
    cats: false,
    catsWelcome: false,
    contactHoursMonday: '',
    contactHoursTuesday: '',
    contactHoursWednesday: '',
    contactHoursThursday: '',
    contactHoursFriday: '',
    contactHoursSaturday: '',
    contactHoursSunday: '',
    contactName: 'j j',
    dateCreated: 'Mar 16, 2021 6:17:48 PM',
    datePhoneVerified: 'Mar 12, 2021 4:43:49 PM',
    dateUpdated: 'Mar 17, 2021 2:21:53 PM',
    dateUpdatedTimestamp: 1616005313319,
    email: 'mockeduser@zillow.com',
    expirationDate: 'Mar 16, 2021 6:17:48 PM',
    fax: '',
    forRentBy: 'owner',
    fullDescription: '',
    furnishedUnitsAvailable: false,
    garageParking: false,
    hardwoodFloors: false,
    hasAnyAirConditioning: false,
    hasDishWasherAppliance: false,
    hasElevator: false,
    hasFitnessCenterCommunityRoom: false,
    hasHardwoodFloorCovering: false,
    hasSwimmingPool: false,
    hasZillowRentConnectBasePackage: false,
    hidePhone: false,
    hideStreetAddress: true,
    isActivationBlocked: false,
    isAddressValid: true,
    isContactEmailInvalid: false,
    isFurnished: false,
    largeDogs: false,
    largeDogsWelcome: false,
    leadGuarantee: {
        isEligible: true,
        maxFreeRenewalCount: 8,
    },
    leaseDuration: '1mo',
    leaseTerms: '',
    needsPhoneVerification: false,
    offStreetParking: false,
    paidInclusion: {
        activeProductType: 1,
        isEnabled: true,
        isPaymentRequired: true,
        isPaymentValid: false,
        isAutoBillEnabled: false,
        canBeActivatedOnMobile: false,
        price: '$9.99',
        paymentValidDuration: 'week',
    },
    petsAllowed: {
        smallDogs: false,
        largeDogs: false,
        cats: false,
        none: false,
    },
    phone: '3522222222',
    previewMessage: '',
    propertyAmenities: [

    ],
    roomForRent: {
        utilitiesIncluded: {

        },
    },
    schedule: [
        {
            day: 'monday',
            morning: false,
            afternoon: false,
            evening: false,
        },
        {
            day: 'tuesday',
            morning: false,
            afternoon: false,
            evening: false,
        },
        {
            day: 'wednesday',
            morning: false,
            afternoon: false,
            evening: false,
        },
        {
            day: 'thursday',
            morning: false,
            afternoon: false,
            evening: false,
        },
        {
            day: 'friday',
            morning: false,
            afternoon: false,
            evening: false,
        },
        {
            day: 'saturday',
            morning: false,
            afternoon: false,
            evening: false,
        },
        {
            day: 'sunday',
            morning: false,
            afternoon: false,
            evening: false,
        },
    ],
    singleFamilyContractDto: {
        isRequired: false,
    },
    smallDogs: false,
    smallDogsWelcome: false,
    specialOffers: [

    ],
    vaultware: false,
    wheelchairAccess: false,
    active: false,
    alias: 4985086348848423943,
    aliasEncoded: '2zmvmfzbqs3g4',
    archived: false,
    canUpdateActiveStatus: true,
    city: 'Los Angeles',
    expirationDateTimestamp: '1615933068838',
    feedId: 'Postlets',
    feedListingId: '1e49zqzwvpq33',
    feedName: 'Zillow Rental Manager',
    floorPlans: [
        {
            id: 'Postlets/1e49zqzwvpq33/2t32ta9sahwbv',
            numBathrooms: 2.0,
            numBedrooms: 0,
            lowPrice: 888.0,
            highPrice: 888.0,
            active: true,
            dateAvailable: '2021-03-16',
            securityDeposit: 99999.0,
            floorPlanPhotos: [

            ],
            unitAmenities: [

            ],
            units: [

            ],
            dateCreated: 'Mar 16, 2021 6:17:48 PM',
        },
    ],
    geo: {
        lat: 34.083643901606,
        lon: -118.19670108394,
    },
    hasVrModels: false,
    isAddressEditable: true,
    isApplicationsAccepted: false,
    isArchived: false,
    isCommunity: false,
    isConnectedExperience: true,
    isContactEmailVerified: true,
    isEditable: true,
    isFeed: false,
    isMultifamily: false,
    isMultiFloorPlan: false,
    isPaidMultifamily: false,
    isPartialResponse: false,
    isPaymentsAccepted: true,
    isPaymentsEnabled: false,
    isPermanent: false,
    isViewable: true,
    isWaitlisted: false,
    listingAlias: '2zmvmfzbqs3g4',
    listingId: '1e49zqzwvpq33_Postlets',
    listingType: {
        display: 'Rental',
        code: 1,
    },
    name: 'Reynolds Ave, Los Angeles',
    permanent: false,
    propertyId: '1e49zqzwvpq33_Postlets',
    propertyPhotos: [
        {
            id: 'da25b859-208b-11eb-ad3d-2ed7db9b480f_Postlets/3xz9z51ytj66e/1',
            rank: 1,
            url: 'https://photonet.hotpads.com/photos/da25b859-208b-11eb-ad3d-2ed7db9b480f.jpg',
        },
        {
            id: 'f60afc3d-208b-11eb-b3d1-3a67c7cfdd07_Postlets/3xz9z51ytj66e/2',
            rank: 2,
            url: 'https://photonet.hotpads.com/photos/f60afc3d-208b-11eb-b3d1-3a67c7cfdd07.jpg',
        },
    ],
    propertyType: {
        display: 'Home',
        code: 6,
    },
    restrictions: {
        isApplicationsRestricted: false,
        isPaymentsRestricted: false,
        isLeasesRestricted: false,
        isAnalyticsRestricted: true,
        isReviewsRestricted: true,
        isContactsRestricted: false,
        isMessagesRestricted: false,
        isUpdateListingRestricted: false,
        isLeaseBuilderRestricted: true,
        isUpdateAgentRestricted: true,
        applications: {
            isAccessRestricted: false,
            isUpdateRestricted: false,
            ownerEmail: 'mockeduser@zillow.com',
        },
    },
    state: 'CA',
    street: '1604 Mock St',
    syndication: {
        hotpads: {
            status: 'Syndication not attempted',
            displayStatus: 'Off Market',
        },
        zillow: {
            status: 'Syndication not attempted',
            displayStatus: 'Off Market',
        },
        trulia: {
            status: 'Syndication not attempted',
            displayStatus: 'Off Market',
        },
        universal: {
            message: '',
            partialMessages: [

            ],
        },
        overview: {
            status: 'inactive',
            displayStatus: 'Inactive',
            publishedCount: 0,
        },
    },
    topDupesDetails: {
        unitId: 2077312501,
        isTopDupe: true,
        topDupeListingId: '1e49zqzwvpq33_Postlets',
        topDupeAliasEncoded: '2zmvmfzbqs3g4',
        dupes: [

        ],
        isPartialResponse: false,
        additionalListingSources: [

        ],
    },
    unit: '',
    vrModels: [

    ],
    zip: '90032',
    zpid: '250221492',
};

const mockPropertyDetailsWithMetroidProductList = {
    ...mockPropertyDetails,
    leadGuarantee: {
        ...mockPropertyDetails.leadGuarantee,
        hasLeadGuarantee: true,
    },
    paidInclusion: {
        ...mockPropertyDetails.paidInclusion,
        isFlatFeeEnabled: false,
        products: [
            {
                type: 1,
                paymentValidDuration: 'week',
                price: '$9.99',
                isEligibleForLeadGuarantee: true,
            },
            {
                type: 2,
                paymentValidDuration: '90 days',
                price: '$30',
                isEligibleForLeadGuarantee: false,
            },
        ],
    },
};

export {
    mockPropertyDetails,
    mockPropertyDetailsWithMetroidProductList,
};
